/**
 * Motivo em português que o servidor devolveu ao recusar um envio (409 fora das 24 h, 502 erro da Meta, 503 sem serviço).
 * Sem mensagem utilizável devolve undefined: a tela segue só com o ícone de erro que já tem.
 */
export function sendFailureText(error: unknown): string | undefined {
  const message = (error as { response?: { data?: { message?: unknown } } })?.response?.data?.message;
  return typeof message === 'string' && message.trim() ? message.trim() : undefined;
}
